import styles from './index.less';
import { Flex, FloatingBall, Tabs } from 'react-vant';
import { useState } from 'react';
import { tabsList } from './config';
import RepairList from '@/pages/RepairManage/components/RepairList';
import { Plus } from '@react-vant/icons';
import { history } from '@umijs/max';

const RepairManage = () => {
  const [activeKey, setActiveKey] = useState<string>('PENDING_PROCESSING,PENDING_DISPATCH,PENDING_ACCEPT,REJECTED,PENDING_REVIEW');


  const handleTabChange = (name: any) => {
    console.log('key', name)
    setActiveKey(name);
  };

  const addWorkOrder = () => {
    history.push('/repairContent')
  }

  return (
    <div className={styles.containerRepair}>
      <Tabs active={activeKey} sticky={true} onChange={handleTabChange}>
        {tabsList.map((item) => (
          <Tabs.TabPane key={item.value} name={item.value} title={item.label}>
            {activeKey === item.value &&<RepairList tabsKey={item.value} />}
          </Tabs.TabPane>
        ))}
      </Tabs>
      <FloatingBall
        offset={{
          right: 20,
          bottom: 130,
        }}
        style={{
          '--rv-floating-box-size': '60px',
        }}
        adsorb={{
          // 滚动缩进比例
          indent: 0.5,
          // 近边停靠距离
          distance: 20,
        }}
        className={styles['floating-btn']}
      >
        <Flex
          onClick={addWorkOrder}
          align={'center'}
          justify={'center'}
          className={styles['main-button']}
        >
          <Plus />
        </Flex>
      </FloatingBall>
    </div>
  );
};

export default RepairManage;
